<template>
  <div class="product-search">
    <el-autocomplete
      v-model="query"
      prefix-icon="el-icon-search"
      placeholder="请输入商品编码/名称"
      :fetch-suggestions="querySearchAsync"
      :popper-append-to-body="false"
      @select="handleSelect"
    >
      <template slot-scope="{item}">
        <div style="font-weight: bold;">
          {{ item.name }}
        </div>
        <div style="color: #909399">
          {{ item.code }}
          <el-divider
            v-if="item.code"
            direction="vertical"
          />
          <el-tag
            size="mini"
            type="info"
          >
            {{ item.dataFrom }}
          </el-tag>
        </div>
      </template>
    </el-autocomplete>
  </div>
</template>

<script>
export default {
  name: 'ProductSearch',
  data() {
    return {
      query: ''
    }
  },
  methods: {
    async querySearchAsync(queryString, cb) {
      const results = await this.ajax.doPost({
        packageName: 'index',
        className: 'search',
        methodName: 'search',
        params: {
          query: queryString
        }
      })

      cb(results)
    },
    handleSelect(e) {
      switch (e.dataFrom) {
        case '一村一品':
          window.open(`/ovop/detail/${e.id}`)
          break
        case '商品营销':
          window.open(`/service/detail/${e.id}`)
          break
        case '生鲜百科':
          window.open(`/product/baike/${e.id}`)
          break
        case '食品百科':
          window.open(`/product/foodBestInfo/${e.id}`)
          break
        default:
      }
    }
  }
}
</script>

<style lang="less">
.product-search {
  border-radius: 17px;
  .el-input {
    background: #f5f5f5;
    // border-radius: 5px;
    border-radius: 17px;
    height: 34px;
    line-height: 34px;
    .el-input__inner {
      height: 34px;
      line-height: 34px;
      border-radius: 17px;
      background: #f5f5f5;
      border: 1px solid #f5f5f5;
    }

    .el-input__inner:hover {
      border: 1px solid rgba(64, 177, 93, 1);
    }

    .el-input__prefix {
      height: 34px;
      line-height: 34px;
      color: #333;

      .el-input__icon {
        height: 34px;
        line-height: 34px;
      }

      input {
        border: 0;
      }
    }
  }

  .name {
    font-weight: bold;
  }

  .code {
    color: #999;
  }

  .el-autocomplete-suggestion {
    width: 300px !important;
  }
}

// .input-with-select .el-input-group__prepend {
//   background-color: #fff;
// }
</style>
